import React from 'react'

type Props = {
  configured: boolean
  onClick: () => void
}

const GuestTaxLink: React.FC<Props> = ({ configured, onClick }) => (
  <button type='button' className='btn btn-link px-0' onClick={onClick}>
    {configured ? 'Edit tax' : 'Add tax'}
  </button>
)

export default GuestTaxLink
